import styled, { css } from 'styled-components';
import { always, cond, propEq, T } from 'ramda';

import { ELEMENTS_TYPES, WIDTH_TYPES } from '../../utils/constants';
import { ContentContainer } from '../layout/layout.styles';

export const Title = styled.h3`
  font-size: 18px;
  font-weight: 600;
  line-height: 1em;
  letter-spacing: 0.9px;
`;

const cardTitleStyle = css`
  text-transform: uppercase;
  font-size: 16px;
  font-weight: 600;
  line-height: 0.88em;
  letter-spacing: 0.8px;
  margin-bottom: 24px;
  color: ${({ theme }) => theme.color};
`;

const cardContentStyle = css`
  font-size: 16px;
  font-weight: 300;
  line-height: 1.69em;
`;

export const CardContent = styled.div`
  ${cond([
    [propEq('type', ELEMENTS_TYPES.PLAIN_TEXT), always(cardTitleStyle)],
    [propEq('type', ELEMENTS_TYPES.MARKDOWN), always(cardContentStyle)],
  ])}
`;

export const Card = styled.div`
  padding: 10px 20px;
  margin: 20px 20px 20px 0;

  :last-child {
    margin-right: 0;
  }
`;

export const CardWrapper = styled.div`
  display: flex;
`;

const colorsStyles = ({ theme }) => css`
  ${Card} {
    background-color: ${theme.background};
  }

  ${Title} {
    color: ${theme.color};
  }
`;

export const Container = styled(ContentContainer)`
  ${colorsStyles}

  ${Card} {
    ${cond([
      [
        propEq('cardType', WIDTH_TYPES.SHORT),
        always(css`
          min-width: calc(33% - 10px);
          width: calc(33% - 10px);
          padding: 30px;
        `),
      ],
      [
        T,
        always(css`
          min-width: calc(50% - 10px);
          width: calc(50% - 10px);
          padding: 36px 45px;
        `),
      ],
    ])}
  }
`;
